import { type CaseReducer, type PayloadAction } from '@reduxjs/toolkit';

import { type FilterGroupState } from '../types';

const loadFiltersCase: CaseReducer<
  FilterGroupState,
  PayloadAction<FilterGroupState>
> = (_, action) => {
  return { ...action.payload };
};

export { loadFiltersCase };
